import { EqualityFn, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../redux/store';

export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types

export const useAppSelector: <Selected>(
  selector: (state: RootState) => Selected,
  equalityFnOrOptions?: EqualityFn<Selected>,
) => Selected = useSelector;
